import React from "react"
import * as S from "./styled"
import { withTrans } from "../../i18n/withTrans"
import ArrowDown from "../../icons/arrowDown.svg"


const AccordionBasics = ({ t, i18n }) => {
    const [ open, setOpen ] = React.useState(false);
  
    const handleClick = () => {
        setOpen(!open);
    };

    return (
/*         <div>   
            <S.AccordionWrapper open={open} key={data[index].id}>
                <div onClick={() => handleClick()}>
                    <h4>{data[index].title}</h4>
                    <span><ArrowDown/></span>
                </div>
                <hr/>
            <S.InternalWrapper open={open} key={data[index].id}>
                <p>{data[index].content}</p>
            </S.InternalWrapper> 
            </S.AccordionWrapper> 
        </div> */
        <div>   
            <S.AccordionWrapper open={open}>
                <div onClick={() => handleClick()} aria-hidden="true">
                    <h4>{t("accordion.titleOne")}</h4>
                    <span><ArrowDown/></span>
                </div>
                <hr/>
            <S.InternalWrapper open={open}>
                <p>{t("accordion.contentOne")}</p>
            </S.InternalWrapper> 
            </S.AccordionWrapper> 
        </div>
    );
};

export default withTrans(AccordionBasics)